import React from 'react';
import { Stack, Text } from '@moda/om';

import './DesktopSiteNavEditorialColumnText.scss';

export const DesktopSiteNavEditorialColumnText: React.FC<{ text: string | null }> = ({ text }) => (
  <Stack alignItems="center" className="DesktopSiteNavEditorialColumnText" space={0}>
    <Text family="serif" treatment="h6">
      {text}
    </Text>
  </Stack>
);
